const routes = [
    {
        path: "/exam/definitions",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        },
        component_full_path: 'examDefinitions/pages/Index.vue'

    },
    {
        path: "/exam/definitions/:id",
        component: () => import("../pages/AddExamEntrance.vue"),
        meta: {
            isAuthenticated: true,
        }
    }
];

export default routes;
